// extracted by mini-css-extract-plugin
export default {"groupListContainer":"UserGroups_groupListContainer__GWiZ4"};